import { ModelBase } from '../../core/model/model-base';
import { EmailDeliveryStatus, EmailDeliveryStatusToString, EmailStatus, EmailStatusToString } from './const/enums';

export class SavedAttachment extends ModelBase {
  constructor() {
    super();
  }
  originalName: string;
  size: number;
}

export class Email extends ModelBase {
  constructor() {
    super();

    this.status = EmailStatus.Created;
  }

  private _createdDateTime: Date;
  private _deliveredDateTime: Date;
  private _sendDateTime: Date;

  body: string;
  subject: string;
  recipientEmailAddress: string;
  emailReceivers: string;
  attachments: File[];
  savedAttachments: SavedAttachment[];

  get createdDateTime(): Date {
    return this._createdDateTime;
  }
  set createdDateTime(value: Date) {
    this._createdDateTime = this.coerceDate(value);
  }

  get deliveredDateTime(): Date {
    return this._deliveredDateTime;
  }
  set deliveredDateTime(value: Date) {
    this._deliveredDateTime = this.coerceDate(value);
  }

  get sendDateTime(): Date {
    return this._sendDateTime;
  }
  set sendDateTime(value: Date) {
    this._sendDateTime = this.coerceDate(value);
  }

  status: EmailStatus;

  deliveryStatus: EmailDeliveryStatus;

  deliveryStatusText: string;

  deliveryInfo: string;

  createdBy: string;
  get statusCaption(): string {
    return EmailStatusToString(this.status);
  }
}
